export default {
  list: '/admin/empresas',
  add: '/admin/agregar-empresa',
}
